/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-const-assign */
import { Box, Checkbox, FormControlLabel, MenuItem, Select, Typography } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';

import {
  FilteringState,
  IntegratedFiltering,
  IntegratedPaging,
  IntegratedSorting,
  PagingState,
  SortingState
} from '@devexpress/dx-react-grid';
import { Grid, PagingPanel, Table, TableFilterRow, TableHeaderRow } from '@devexpress/dx-react-grid-material-ui';
import { Button, InputAdornment, Paper, TableRow, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import SelectedCommentAndNotesComponent from './selectedCommentAndNotes.component';
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import {
  ExceptionCategoryOptions,
  ExceptionCodeOptions,
  ExceptionRequestTypeOptions,
  ExceptionStatusOptions,
  SearchableProperties
} from './commentAndNotesConstants';
import { ExceptionId } from '../notesAndCommunicationEditableCard.component';
import {
  deleteAuthCommentsAttachment,
  deleteAuthorizationComment,
  getAuthorizationComments,
  postAuthorizationComment
} from 'modules/authorizations/store/actions/authorizations.actions';
import {
  DELETE_AUTH_COMMENTS_ATTACHMENT_FAILURE,
  DELETE_AUTHORIZATION_COMMENTS_FAILURE,
  POST_AUTHORIZATION_COMMENTS_FAILURE
} from 'modules/authorizations/store/types/authorizationTypes';
import { showToast } from 'modules/layout/layout.actions';
import { ZERO_GUID } from 'modules/enumerations/enumerationIds';
import { formatMoney } from 'utilities/currencyFormatter';

export const formatDate = date => {
  if (!date) return '';
  try {
    const parsedDate = new Date(date);
    if (isNaN(parsedDate)) return '';

    // Format YYYY-MM-DD HH:MM:SS
    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');
    // const hours = String(parsedDate.getHours()).padStart(2, '0');
    // const minutes = String(parsedDate.getMinutes()).padStart(2, '0');
    // const seconds = String(parsedDate.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  } catch {
    return '';
  }
};

export const createDefaultComment = (serviceOptionId, localStorage, regardingOptionId = null) => {
  return {
    commentId: null,
    authorizationExceptionCommentId: null,
    authorizationCommentId: null,
    addedByUserId: 0,
    modifiedByUserId: 0,
    serviceId: serviceOptionId,
    regardingId: regardingOptionId,
    isTransfereeViewable: false,
    isClientViewable: false,
    isPinned: false,
    subject: null,
    comment: null,
    exceptionReason: null,
    requestedAmount: null,
    categoryId: null,
    exceptionCodeId: ZERO_GUID,
    expenseCodeId: null,
    statusId: null,
    requestTypeId: null,
    approvedAmount: null,
    approvedById: null,
    approvedDate: null
  };
};

const customFilterCell = props => {
  if (props.column?.type === 'dropdown') {
    return (
      <TableFilterRow.Cell {...props}>
        <Select
          value={props.filter ? props.filter.value : ''}
          onChange={event => {
            const value = event.target.value;
            props.onFilter(value ? { value, operation: 'equal' } : null);
          }}
          displayEmpty
          fullWidth
          variant="standard"
          sx={{ fontSize: '0.75rem' }}
        >
          <MenuItem value="" sx={{ fontSize: '0.75rem' }}>
            All
          </MenuItem>
          {props.column.options.map(option => (
            <MenuItem key={option.id} value={option.title} sx={{ fontSize: '0.75rem' }}>
              {option.title}
            </MenuItem>
          ))}
        </Select>
      </TableFilterRow.Cell>
    );
  }

  return <TableFilterRow.Cell {...props} />;
};

const createLookupMap = arr =>
  arr.reduce((acc, item) => {
    acc[item.id] = item.title;
    return acc;
  }, {});

const CommentsAndNotes = props => {
  const {
    authorizationId,
    details,
    viewMode = 'fullView',
    serviceOptionId,
    regardingOptionId,
    enumerations,
    filterString,
    initialCommentId,
    clientInfo,
    expenseCodes,
    registerLeaveGuard: registerPanelLeaveGuard,
    isReadOnly = false,
    allowReadOnlySelection = false
  } = props;
  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });
  const clientContacts = clientInfo && clientInfo.clientDetails ? clientInfo.clientDetails.clientContacts : [];
  const serviceOptions = enumerations?.allEnums?.authCommentService || [];
  const regardingOptions = enumerations?.allEnums?.authCommentRegarding || [];

  const serviceLookup = createLookupMap(serviceOptions);
  const regardingLookup = createLookupMap(regardingOptions);
  const exceptionCategoryLookup = createLookupMap(ExceptionCategoryOptions);
  const exceptionStatusLookup = createLookupMap(ExceptionStatusOptions);
  const exceptionCodeLookup = createLookupMap(ExceptionCodeOptions);
  const exceptionRequestTypeLookup = createLookupMap(ExceptionRequestTypeOptions);

  const allNotes = useMemo(() => {
    const notes = details.commentsAndNotes ? [...details.commentsAndNotes] : [];
    let pinnedNotes = notes.filter(n => n.isPinned);
    let unpinnedNotes = notes.filter(n => !n.isPinned);
    return [...pinnedNotes, ...unpinnedNotes];
  }, [details.commentsAndNotes]);

  const allDocs = useMemo(() => {
    return details.commentsAndNotesWithAttachments ? [...details.commentsAndNotesWithAttachments] : [];
  }, [details.commentsAndNotesWithAttachments]);

  // Derived from the store so uploads, edits and deletes in the detail panel show in the Docs view right away
  const allDocRows = useMemo(() => {
    const docRows = allDocs.flatMap(c =>
      (c.attachments || []).map(a => ({
        attachmentId: a.attachmentId,
        commentId: a.commentId,
        serviceId: c.info.serviceId,
        regardingId: c.info.regardingId,
        fileExtension: a.fileExtension,
        fileName: a.fileName,
        fileSize: a.fileSize,
        isWebViewable: a.isWebViewable,
        description: a.description,
        uploadedOn: a.uploadedOn,
      })),
    );
    return docRows.sort((a, b) => new Date(b.uploadedOn) - new Date(a.uploadedOn));
  }, [allDocs]);

  const [isLoading, setIsLoading] = useState(false);
  const [isNewComment, setIsNewComment] = useState(false);
  const [unsavedCommentId, setUnsavedCommentId] = useState(null);
  const discardedUnsavedCommentIds = useRef(new Set());
  const [selectedComment, setSelectedComment] = useState(
    initialCommentId && initialCommentId > 0
      ? allNotes && allNotes.length > 0
        ? allNotes.find(s => s.commentId === initialCommentId)
        : null
      : null
  );
  const [showExpenseDetails, setShowExpenseDetails] = useState(regardingOptionId === ExceptionId);
  const [showComments, setShowComments] = useState(true);
  const canOpenDetailPanel = !isReadOnly || allowReadOnlySelection;
  const appliedInitialCommentId = useRef(null);
  const leaveGuard = useRef(null);
  const registerLeaveGuard = useMemo(() => guard => {
    leaveGuard.current = guard;
    return () => {
      if (leaveGuard.current === guard) leaveGuard.current = null;
    };
  }, []);
  const requestLeave = action => {
    if (leaveGuard.current) leaveGuard.current(action);
    else action();
  };
  const resolveUnsavedComment = commentId => {
    setUnsavedCommentId(current => (current === commentId ? null : current));
  };
  const handleUnsavedCommentDeleted = commentId => {
    discardedUnsavedCommentIds.current.add(commentId);
    resolveUnsavedComment(commentId);
  };

  useEffect(() => {
    if (!registerPanelLeaveGuard) return;
    return registerPanelLeaveGuard(requestLeave);
  }, [registerPanelLeaveGuard]);

  const saveComment = async () => {
    setIsLoading(true);
    const resp = await props.postAuthorizationComment(
      {
        isClientViewable: false,
        isPinned: false,
        isTransfereeViewable: false,
        regardingId: '00000000-0000-0000-0000-000000000000',
        serviceId: serviceOptionId ?? '00000000-0000-0000-0000-000000000000',
      },
      authorizationId
    );

    if (resp.type === POST_AUTHORIZATION_COMMENTS_FAILURE) {
      props.showToast('Failed to create comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } else {
      await props.getAuthorizationComments(authorizationId);

      props.showToast('Comment created successfully', TOAST_MESSAGE_SEVERITY_SUCCESS);
      setIsNewComment(false);
      const newest = resp.response.reduce((latest, current) => {
        return new Date(current.addedOn) > new Date(latest.addedOn) ? current : latest;
      });

      setUnsavedCommentId(newest.commentId);
      setSelectedComment(newest);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (viewMode === 'fullView' && allNotes.length > 0) {
      if (initialCommentId && initialCommentId !== appliedInitialCommentId.current) {
        const match = allNotes.find(n => n.commentId === initialCommentId);
        if (match) {
          // Apply the linked comment once, so a later refresh doesn't undo the user's selection or deselection
          appliedInitialCommentId.current = initialCommentId;
          setSelectedComment(match);
          return;
        }
      }

      const filteredNotes = filterString ? allNotes.filter(note => note.serviceId === filterString) : allNotes;
      if (filteredNotes.length === 0) {
        setSelectedComment(null);
        return;
      }

      // const newestComment = filteredNotes.reduce((latest, current) =>
      //   new Date(current.addedOn) > new Date(latest.addedOn) ? current : latest
      // );

      // setSelectedComment(newestComment);
    }
  }, [viewMode, details.commentsAndNotes, initialCommentId, filterString]);

  const openDocuments = () => {
    setFilteredRows(allDocRows);
    setShowComments(false);
  };

  const onDeleteComment = commentId => {
    const deleteComment = () => deleteCommentConfirmed(commentId);
    if (commentId === selectedComment?.commentId) requestLeave(deleteComment);
    else deleteComment();
  };

  const deleteCommentConfirmed = async commentId => {
    if (discardedUnsavedCommentIds.current.delete(commentId)) {
      setSelectedComment(null);
      return;
    }
    setIsLoading(true);
    try {
      const resp = await props.deleteAuthorizationComment(authorizationId, commentId);
      if (resp.type === DELETE_AUTHORIZATION_COMMENTS_FAILURE) {
        props.showToast('Failed to delete comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
      } else {
        await props.getAuthorizationComments(authorizationId);
        props.showToast('Comment deleted successfully', TOAST_MESSAGE_SEVERITY_SUCCESS);
        if (commentId === selectedComment?.commentId) {
          setSelectedComment(null);
        }
      }
    } catch {
      props.showToast('Failed to delete comment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    }
    setIsLoading(false);
  };

  const onDeleteFile = async (commentId, attachmentId) => {
    setIsLoading(true);
    const deleteFileResp = await props.deleteAuthCommentsAttachment(authorizationId, commentId, attachmentId);
    if (deleteFileResp.type === DELETE_AUTH_COMMENTS_ATTACHMENT_FAILURE) {
      props.showToast('Failed to delete attachment, please try again later', TOAST_MESSAGE_SEVERITY_ERROR);
    } else {
      const commentsResp = await props.getAuthorizationComments(authorizationId);
      allDocs = commentsResp.response;
      props.showToast('Successfully deleted attachment', TOAST_MESSAGE_SEVERITY_SUCCESS);
      if (commentId === selectedComment?.commentId) {
        setSelectedComment(null);
      }
    }
    setIsLoading(false);
    openDocuments();
  };

  const onRowClick = rowData => {
    if (!canOpenDetailPanel) return;
    // Docs view rows are attachments, so select the comment they belong to
    const comment = allNotes.find(n => n.commentId === rowData.commentId) || rowData;
    const isAlreadySelected = comment.commentId === selectedComment?.commentId;
    requestLeave(() => {
      setIsNewComment(false);
      // Clicking the selected row again deselects it, which clears the form
      setSelectedComment(isAlreadySelected ? null : comment);
    });
  };

  const renderHeaderRow = row => {
    return (
      <TableRow sx={{ backgroundColor: '#41B7C0', '& .MuiButtonBase-root': { color: 'white !important' } }}>
        {row.children.map(c => {
          return c;
        })}
      </TableRow>
    );
  };

  const [sorting, setSorting] = useState([]);
  // { columnName: 'addedOn', direction: 'desc' }
  const removeHtml = comment => {
    if (typeof comment !== 'string') {
      return '';
    }

    const plainText = comment.replace(/<[^>]*>?/gm, '');

    return plainText;
  };

  const baseTableColumnExtensions = [
    { columnName: 'serviceId', width: 140 },
    { columnName: 'regardingId', width: 140 },
    { columnName: 'attachments', width: 120 },
    { columnName: 'addedOn', width: 135 }
  ];

  const baseTableDocColumnExtensions = [
    { columnName: 'serviceId', width: 160 },
    { columnName: 'regardingId', width: 170 },
    { columnName: 'uploadedOn', width: 135 }
  ];

  const expenseTableColumnExtensions = [
    { columnName: 'serviceId', width: 140 },
    { columnName: 'regardingId', width: 140 },
    { columnName: 'statusId', width: 110 },
    { columnName: 'requestedAmount', width: 130 },
    { columnName: 'approvedAmount', width: 130 },
    { columnName: 'addedOn', width: 135 }
  ];

  const baseColumns = [
    { name: 'addedOn', title: 'Created Date', getCellValue: row => formatDate(row.addedOn) },
    {
      name: 'serviceId',
      title: 'Service',
      getCellValue: row => serviceOptions.find(opt => opt.id === row.serviceId)?.title || '',
      type: 'dropdown',
      options: serviceOptions
    },
    {
      name: 'regardingId',
      title: 'Regarding',
      getCellValue: row => regardingOptions.find(opt => opt.id === row.regardingId)?.title || '',
      type: 'dropdown',
      options: regardingOptions
    },
    {
      name: 'attachments',
      title: 'Attachments',
      getCellValue: row => allDocs.find(c => c.info.commentId === row.commentId)?.attachments?.length || 0
    },
    {
      name: 'subject',
      title: 'Subject',
      getCellValue: row => row.subject || ''
    },
    {
      name: 'comment',
      title: 'Comment',
      getCellValue: row => removeHtml(row.comment) || ''
    }
  ];

  const docColumns = [
    {
      name: 'serviceId',
      title: 'Service',
      getCellValue: row => serviceOptions.find(opt => opt.id === row.serviceId)?.title || '',
      type: 'dropdown',
      options: serviceOptions
    },
    {
      name: 'regardingId',
      title: 'Regarding',
      getCellValue: row => regardingOptions.find(opt => opt.id === row.regardingId)?.title || '',
      type: 'dropdown',
      options: regardingOptions
    },
    { name: 'uploadedOn', title: 'Created Date', getCellValue: row => formatDate(row.uploadedOn) },
    { name: 'fileName', title: 'Document Name', getCellValue: row => row.fileName },
    { name: 'isWebViewable', title: 'Shared with EE', getCellValue: row => (row.isWebViewable ? 'Yes' : 'No') },
    { name: 'description', title: 'EE Description', getCellValue: row => row.description }
  ];

  const formatCurrency = amount => {
    if (amount == null || isNaN(amount)) return '-';
    return formatMoney(amount);
  };

  const expenseDetailColumns = [
    { name: 'addedOn', title: 'Created Date', getCellValue: row => formatDate(row.addedOn) },
    {
      name: 'serviceId',
      title: 'Service',
      getCellValue: row => serviceOptions.find(opt => opt.id === row.serviceId)?.title || '',
      type: 'dropdown',
      options: serviceOptions
    },
    {
      name: 'regardingId',
      title: 'Regarding',
      getCellValue: row => regardingOptions.find(opt => opt.id === row.regardingId)?.title || '',
      type: 'dropdown',
      options: regardingOptions
    },
    {
      name: 'statusId',
      title: 'Status',
      getCellValue: row => ExceptionStatusOptions.find(opt => opt.id === row.statusId)?.title || '',
      type: 'dropdown',
      options: ExceptionStatusOptions
    },
    {
      name: 'requestedMoney',
      title: 'Requested Amt',
      getCellValue: row => formatCurrency(row.requestedMoney)
    },
    {
      name: 'approvedAmount',
      title: 'Approved Amt',
      getCellValue: row => formatCurrency(row.approvedAmount)
    }
  ];

  const columns = showExpenseDetails ? expenseDetailColumns : baseColumns;
  const tableColumnExtensions = showExpenseDetails ? expenseTableColumnExtensions : baseTableColumnExtensions;

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [pageSizes] = useState([15, 20, 25]);
  const [filters, setFilters] = useState(
    serviceOptionId
      ? [{ columnName: 'serviceId', value: serviceOptions.find(s => s.id === serviceOptionId)?.title }]
      : regardingOptionId
        ? [{ columnName: 'regardingId', value: regardingOptions.find(s => s.id === regardingOptionId)?.title }]
        : []
  );
  const [filterText, setFilterText] = useState('');
  const [filteredRows, setFilteredRows] = useState(allNotes);

  useEffect(() => {
    setFilteredRows(handleFilterRowsChange());
  }, [allNotes, allDocRows, filterText, showComments]);

  const handleFilterChange = e => {
    setFilterText(e.target.value);
  };

  const handleFilterRowsChange = () => {
    const searchText = filterText.trim().toLowerCase();
    if (showComments) {

      if (!searchText) return allNotes;

      return allNotes.filter(note =>
        Object.entries(note).some(([key, value]) => {
          if (!SearchableProperties.has(key) || value == null) return false;

          let stringValue = value
            .toString()
            .trim()
            .toLowerCase();

          if (key === 'serviceId' && serviceLookup[value]) {
            stringValue = serviceLookup[value].toLowerCase();
          } else if (key === 'regardingId' && regardingLookup[value]) {
            stringValue = regardingLookup[value].toLowerCase();
          } else if (key === 'categoryId' && exceptionCategoryLookup[value]) {
            stringValue = exceptionCategoryLookup[value].toLowerCase();
          } else if (key === 'statusId' && exceptionStatusLookup[value]) {
            stringValue = exceptionStatusLookup[value].toLowerCase();
          } else if (key === 'exceptionCodeId' && exceptionCodeLookup[value]) {
            stringValue = exceptionCodeLookup[value].toLowerCase();
          } else if (key === 'requestTypeId' && exceptionRequestTypeLookup[value]) {
            stringValue = exceptionRequestTypeLookup[value].toLowerCase();
          }

          return stringValue.includes(searchText);
        })
      );
    } else {
      if (!searchText) return allDocRows;

      return allDocRows.filter(note =>
        Object.entries(note).some(([key, value]) => {
          if (!SearchableProperties.has(key) || value == null) return false;

          let stringValue = value
            .toString()
            .trim()
            .toLowerCase();

          if (key === 'serviceId' && serviceLookup[value]) {
            stringValue = serviceLookup[value].toLowerCase();
          } else if (key === 'regardingId' && regardingLookup[value]) {
            stringValue = regardingLookup[value].toLowerCase();
          }

          return stringValue.includes(searchText);
        })
      );
    }
  };

  const iconAdornment = {
    startAdornment: (
      <InputAdornment position="start">
        <FontAwesomeIcon size="1x" icon={['fas', 'fa-magnifying-glass']} color="gray" />
      </InputAdornment>
    )
  };

  return (
    <ThemeProvider theme={theme}>
      {isLoading && <FullscreenSpinner />}
      {viewMode === 'fullView' && (
        <Box display="flex" width="100%" height="100%">
          <Box sx={{ padding: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TextField
                placeholder="Search..."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FontAwesomeIcon size="1x" icon={['fas', 'magnifying-glass']} color="gray" />
                    </InputAdornment>
                  )
                }}
                sx={{
                  width: '350px',
                  paddingBottom: '5px'
                }}
                value={filterText}
                onChange={e => handleFilterChange(e)}
                disabled={isReadOnly}
              />
              {!isReadOnly && (
                <Button color="primary" variant="contained" sx={{ height: '36px' }} onClick={() => requestLeave(saveComment)}>
                  Create Comment
                </Button>
              )}
              <Button
                color="secondary"
                variant="contained"
                sx={{
                  maxHeight: '40px',
                  marginLeft: '12px',
                  backgroundColor: showComments ? '#5D9878' : '#ffffff',
                  '&:hover': { backgroundColor: showComments ? '#416A54' : '#faf8f2' },
                  color: showComments ? 'ffffff' : '#080600'
                }}
                onClick={() => setShowComments(true)}
              >
                {' '}
                See Comments{' '}
              </Button>
              <Button
                color="secondary"
                type="submit"
                variant="contained"
                sx={{
                  maxHeight: '40px',
                  backgroundColor: !showComments ? '#5D9878' : '#ffffff',
                  '&:hover': { backgroundColor: !showComments ? '#416A54' : '#faf8f2' },
                  color: !showComments ? 'ffffff' : '#080600'
                }}
                onClick={() => openDocuments()}
              >
                {' '}
                See Docs{' '}
              </Button>
            </Box>
            {showComments && (
              <>
                <Box sx={{ marginTop: '4px', display: 'flex', alignItems: 'center' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={showExpenseDetails}
                        onChange={() => setShowExpenseDetails(prev => !prev)}
                        color="primary"
                        size="small"
                      />
                    }
                    label={<Typography sx={{ fontSize: '0.75rem' }}>Show Exception Details</Typography>}
                    sx={{ marginLeft: '5px' }}
                  />
                </Box>
              </>
            )}

            <Paper>
              {showComments && (
                <>
                  <Grid rows={filteredRows} columns={columns}>
                    <SortingState sorting={sorting} onSortingChange={setSorting} />
                    <IntegratedSorting />
                    <PagingState
                      currentPage={currentPage}
                      onCurrentPageChange={setCurrentPage}
                      pageSize={pageSize}
                      onPageSizeChange={setPageSize}
                    />
                    <FilteringState filters={filters} onFiltersChange={setFilters} />
                    <IntegratedFiltering />
                    <IntegratedPaging />
                    <Table
                      columnExtensions={tableColumnExtensions}
                      cellComponent={props => {
                        const { column, row, ...restProps } = props;
                        if (column.name === 'addedOn') {
                          return (
                            <Table.Cell {...restProps}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <IconButton
                                  color="error"
                                  disabled={isReadOnly}
                                  onClick={e => {
                                    if (isReadOnly) return;
                                    e.stopPropagation();
                                    onDeleteComment(row.commentId);
                                  }}
                                  sx={{
                                    marginLeft: '-20px'
                                  }}
                                >
                                  <Delete />
                                </IconButton>
                                <Typography
                                  sx={{
                                    fontSize: 'inherit',
                                    color: 'inherit',
                                    lineHeight: 1.5,
                                    marginLeft: '-15px'
                                  }}
                                >
                                  {formatDate(row.addedOn)}
                                </Typography>
                              </Box>
                            </Table.Cell>
                          );
                        }
                        return <Table.Cell {...props} />;
                      }}
                      rowComponent={props => {
                        const rowStyle = {
                          cursor: canOpenDetailPanel ? 'pointer' : 'default',
                          backgroundColor: props.row.isPinned ? '#f07c5f' : (props.row.commentId === selectedComment?.commentId ? '#f5f5f5' : 'white'),
                          color: props.row.isPinned ? '#ffffff' : 'inherit'
                        };

                        const hoverStyle = {
                          backgroundColor: '#f5f5f5',
                          color: '#000'
                        };

                        return (
                          <Table.Row
                            {...props}
                            onClick={() => onRowClick(props.row)}
                            style={rowStyle}
                            onMouseEnter={e => {
                              if (!canOpenDetailPanel) return;
                              Object.assign(e.currentTarget.style, hoverStyle);
                            }}
                            onMouseLeave={e => {
                              if (!canOpenDetailPanel) return;
                              Object.assign(e.currentTarget.style, rowStyle);
                            }}
                          />
                        );
                      }}
                    />
                    <TableHeaderRow rowComponent={renderHeaderRow} showSortingControls />
                    <TableFilterRow cellComponent={customFilterCell} />
                    <PagingPanel pageSizes={pageSizes} />
                  </Grid>
                </>
              )}
              {!showComments && (
                <>
                  <Grid rows={filteredRows} columns={docColumns}>
                    <SortingState sorting={sorting} onSortingChange={setSorting} />
                    <IntegratedSorting />
                    <PagingState
                      currentPage={currentPage}
                      onCurrentPageChange={setCurrentPage}
                      pageSize={pageSize}
                      onPageSizeChange={setPageSize}
                    />
                    <FilteringState filters={filters} onFiltersChange={setFilters} />
                    <IntegratedFiltering />
                    <IntegratedPaging />
                    <Table
                      columnExtensions={baseTableDocColumnExtensions}
                      cellComponent={props => {
                        const { column, row, ...restProps } = props;
                        if (column.name === 'addedOn') {
                          return (
                            <Table.Cell {...restProps}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <IconButton
                                  color="error"
                                  disabled={isReadOnly}
                                  onClick={e => {
                                    if (isReadOnly) return;
                                    e.stopPropagation();
                                    onDeleteFile(row.commentId, row.attachmentId);
                                  }}
                                  sx={{
                                    marginLeft: '-20px'
                                  }}
                                >
                                  <Delete />
                                </IconButton>
                                <Typography
                                  sx={{
                                    fontSize: 'inherit',
                                    color: 'inherit',
                                    lineHeight: 1.5,
                                    marginLeft: '-15px'
                                  }}
                                >
                                  {formatDate(row.addedOn)}
                                </Typography>
                              </Box>
                            </Table.Cell>
                          );
                        }
                        return <Table.Cell {...props} />;
                      }}
                      rowComponent={props => {
                        const rowStyle = {
                          cursor: canOpenDetailPanel ? 'pointer' : 'default',
                          backgroundColor: props.row.commentId === selectedComment?.commentId ? '#f5f5f5' : 'white'
                        };

                        const hoverStyle = {
                          backgroundColor: '#f5f5f5',
                          color: '#000'
                        };

                        return (
                          <Table.Row
                            {...props}
                            onClick={() => onRowClick(props.row)}
                            style={rowStyle}
                            onMouseEnter={e => {
                              if (!canOpenDetailPanel) return;
                              Object.assign(e.currentTarget.style, hoverStyle);
                            }}
                            onMouseLeave={e => {
                              if (!canOpenDetailPanel) return;
                              Object.assign(e.currentTarget.style, rowStyle);
                            }}
                          />
                        );
                      }}
                    />
                    <TableHeaderRow rowComponent={renderHeaderRow} showSortingControls />
                    <TableFilterRow cellComponent={customFilterCell} />
                    <PagingPanel pageSizes={pageSizes} />
                  </Grid>
                </>
              )}
            </Paper>
          </Box>
          {canOpenDetailPanel && (
            <Box flex={1}>
              <SelectedCommentAndNotesComponent
                selectedComment={selectedComment}
                setSelectedComment={setSelectedComment}
                isUnsavedComment={selectedComment?.commentId === unsavedCommentId}
                onUnsavedCommentResolved={resolveUnsavedComment}
                onUnsavedCommentDeleted={handleUnsavedCommentDeleted}
                registerLeaveGuard={registerLeaveGuard}
                setIsLoading={setIsLoading}
                authorizationId={authorizationId}
                isNewComment={isNewComment}
                enumerations={enumerations}
                internalUsers={props.internalUsers}
                internalUserTypesEnum={props.internalUserTypesEnum}
                commentsAndNotesWithAttachments={details.commentsAndNotesWithAttachments ? details.commentsAndNotesWithAttachments : []}
                defaultEmail={details.authorizationDetails?.webAccessEmailAddress}
                clientContacts={clientContacts}
                expenseCodes={expenseCodes}
                isReadOnly={isReadOnly}
              />
            </Box>
          )}
        </Box>
      )}
      {viewMode !== 'fullView' && (
        <Box display="flex" width="100%" height="100%">
          {!selectedComment && (
            <Box sx={{ padding: 3 }}>
              <Box sx={{ flexDirection: 'row' }}>
                <TextField
                  diabled={true}
                  placeholder="Search..."
                  InputProps={iconAdornment}
                  sx={{ paddingBottom: '10px' }}
                  value={filterText}
                  onChange={e => handleFilterChange(e)}
                />
                <Button color="primary" variant="contained" sx={{ marginLeft: '10px', marginTop: '5px' }} onClick={saveComment}>
                  Create Comment
                </Button>
              </Box>
              <Paper>
                <Grid rows={filteredRows} columns={columns}>
                  <SortingState sorting={sorting} onSortingChange={setSorting} />
                  <IntegratedSorting />
                  <PagingState
                    currentPage={currentPage}
                    onCurrentPageChange={setCurrentPage}
                    pageSize={pageSize}
                    onPageSizeChange={setPageSize}
                  />
                  <FilteringState filters={filters} onFiltersChange={setFilters} />
                  <IntegratedFiltering />
                  <IntegratedPaging />
                  <Table
                    columnExtensions={tableColumnExtensions}
                    cellComponent={props => {
                      const { column, row, ...restProps } = props;
                      if (column.name === 'serviceId') {
                        return (
                          <Table.Cell {...restProps}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                              <IconButton
                                color="error"
                                onClick={e => {
                                  e.stopPropagation();
                                  onDeleteComment(row.commentId);
                                }}
                                sx={{
                                  marginLeft: '-20px'
                                }}
                              >
                                <Delete />
                              </IconButton>
                              <Typography
                                sx={{
                                  fontSize: 'inherit',
                                  color: 'inherit',
                                  lineHeight: 1.5,
                                  marginLeft: '-15px'
                                }}
                              >
                                {serviceOptions.find(opt => opt.id === row.serviceId)?.title || ''}
                              </Typography>
                            </Box>
                          </Table.Cell>
                        );
                      }
                      return <Table.Cell {...props} />;
                    }}
                    rowComponent={props => {
                      const rowStyle = {
                        cursor: 'pointer',
                        backgroundColor: 'white'
                      };

                      const hoverStyle = {
                        backgroundColor: '#f5f5f5',
                        color: '#000'
                      };

                      return (
                        <Table.Row
                          {...props}
                          onClick={() => onRowClick(props.row)}
                          style={rowStyle}
                          onMouseEnter={e => {
                            Object.assign(e.currentTarget.style, hoverStyle);
                          }}
                          onMouseLeave={e => {
                            Object.assign(e.currentTarget.style, rowStyle);
                          }}
                        />
                      );
                    }}
                  />
                  <TableHeaderRow rowComponent={renderHeaderRow} showSortingControls />
                  <TableFilterRow cellComponent={customFilterCell} />
                  <PagingPanel pageSizes={pageSizes} />
                </Grid>
              </Paper>
            </Box>
          )}
          {selectedComment && (
            <Box flex={1}>
              <SelectedCommentAndNotesComponent
                selectedComment={selectedComment}
                setSelectedComment={setSelectedComment}
                isUnsavedComment={selectedComment?.commentId === unsavedCommentId}
                onUnsavedCommentResolved={resolveUnsavedComment}
                onUnsavedCommentDeleted={handleUnsavedCommentDeleted}
                registerLeaveGuard={registerLeaveGuard}
                setIsLoading={setIsLoading}
                authorizationId={authorizationId}
                isNewComment={isNewComment}
                halfView={true}
                enumerations={enumerations}
                internalUsers={props.internalUsers}
                internalUserTypesEnum={props.internalUserTypesEnum}
                commentsAndNotesWithAttachments={details.commentsAndNotesWithAttachments ? details.commentsAndNotesWithAttachments : []}
                defaultEmail={details.authorizationDetails?.webAccessEmailAddress}
                clientContacts={clientContacts}
                expenseCodes={expenseCodes}
              />
            </Box>
          )}
        </Box>
      )}
    </ThemeProvider>
  );
};

const mapStateToProps = state => ({});

export default compose(
  connect(mapStateToProps, {
    deleteAuthorizationComment,
    deleteAuthCommentsAttachment,
    postAuthorizationComment,
    showToast,
    getAuthorizationComments
  })
)(CommentsAndNotes);
